import { lazy } from '@atlassian/react-loosely-lazy';

// Make sure there is only one place in JFE which imports value (not type) from `@atlaskit/feedback-collector`
// because we want to load AK Feedback Dialog lazily

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyFeedbackCollectorDialog = lazy(
	() =>
		import(
			/* webpackChunkName: "async-feedback-collector-dialog" */ '@atlaskit/feedback-collector'
		),
	{ ssr: false },
);
